import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
import { CustomCodeBlock as CodeBlock } from '@edusense/shared-ui-content';
const Container = styled.div`
  margin: var(--theme-spacing-lg, 24px) 0;
  border: 1px solid var(--vscode-editorWidget-border, var(--theme-border));
  border-radius: var(--theme-radius-md, 8px);
  overflow: hidden;
`;
const Title = styled.h4`
  margin: 0;
  padding: var(--theme-spacing-md, 16px);
  background: var(--vscode-editor-background, var(--theme-paper));
  border-bottom: 1px solid var(--vscode-editorWidget-border, var(--theme-border));
  font-size: var(--theme-typography-font-size-base, 1rem);
  font-weight: var(--theme-typography-font-weight-semibold, 600);
  color: var(--vscode-editor-foreground, var(--theme-text));
`;
const CompareContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
const CodePane = styled.div`
  position: relative;
  
  &:first-of-type {
    border-right: 1px solid var(--vscode-editorWidget-border, var(--theme-border));
  }
  
  @media (max-width: 768px) {
    &:first-of-type {
      border-right: none;
      border-bottom: 1px solid var(--vscode-editorWidget-border, var(--theme-border));
    }
  }
`;
const PaneLabel = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  background: var(--vscode-editor-background, var(--theme-paper));
  border: 1px solid var(--vscode-editorWidget-border, var(--theme-border));
  padding: 4px 8px;
  border-radius: var(--theme-radius-sm, 4px);
  font-size: var(--theme-typography-font-size-xs, 0.75rem);
  font-weight: var(--theme-typography-font-weight-medium, 500);
  color: var(--vscode-descriptionForeground, var(--theme-text-secondary));
  z-index: 10;
`;
const StyledCodeBlock = styled.div`
  > div {
    margin: 0;
    border-radius: 0;
    border: none;
  }
`;
const CodeCompare = ({ title, left, right })=>{
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            title && /*#__PURE__*/ _jsx(Title, {
                children: title
            }),
            /*#__PURE__*/ _jsxs(CompareContainer, {
                children: [
                    /*#__PURE__*/ _jsxs(CodePane, {
                        children: [
                            /*#__PURE__*/ _jsx(PaneLabel, {
                                children: left.label
                            }),
                            /*#__PURE__*/ _jsx(StyledCodeBlock, {
                                children: /*#__PURE__*/ _jsx(CodeBlock, {
                                    language: left.language,
                                    children: left.code
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(CodePane, {
                        children: [
                            /*#__PURE__*/ _jsx(PaneLabel, {
                                children: right.label
                            }),
                            /*#__PURE__*/ _jsx(StyledCodeBlock, {
                                children: /*#__PURE__*/ _jsx(CodeBlock, {
                                    language: right.language,
                                    children: right.code
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default CodeCompare;
